// =====================================================
// 📁 quotationHistoryColumns.ts
// =====================================================

import { CustomColumn } from '../../../types/customColumn';

import { QuotationHistoryTableDTO } from '../../../types/sale/quotation/history/QuotationHistoryTableDTO';

import { formatCurrency } from '../../../utils/formatCurrency';

import {
  formatDateOnly,
  formatFriendlyDateTime,
} from '../../../utils/dateFormatters';

export const quotationHistoryColumns: CustomColumn<QuotationHistoryTableDTO>[] =
  [
    // =====================================================
    // 🔹 Cotización
    // =====================================================

    {
      Header: 'Cotización',

      accessor: 'quotationNumber',

      customCell: ({ row }) => (
        <div className="min-w-[190px]">
          <div
            className="
              font-semibold
              text-black

              dark:text-white
            "
          >
            {row.original.quotationNumber || '—'}
          </div>

          <div
            className="
              mt-1

              text-xs
              text-body
            "
          >
            {row.original.branchName || 'Sin sucursal'}
          </div>
        </div>
      ),
    },

    // =====================================================
    // 🔹 Cliente
    // =====================================================

    {
      Header: 'Cliente',

      accessor: 'customerName',

      customCell: ({ value }) => (
        <div className="min-w-[240px] max-w-[320px]">
          <p
            className="
              whitespace-normal
              break-words

              font-medium
              leading-6

              text-black

              dark:text-white
            "
          >
            {value || 'Cliente general'}
          </p>
        </div>
      ),
    },

    // =====================================================
    // 🔹 Información
    // =====================================================

    {
      Header: 'Información',

      accessor: 'sellerName',

      customCell: ({ row }) => (
        <div className="min-w-[220px] space-y-1">
          {/* 🔹 Seller */}

          <div
            className="
              text-sm
              font-medium

              text-black

              dark:text-white
            "
          >
            {row.original.sellerName || 'Sin vendedor'}
          </div>

          {/* 🔹 Dates */}

          <div
            className="
              text-xs
              text-body
            "
          >
            Fecha: {formatFriendlyDateTime(row.original.quotationDate) || '—'}
          </div>

          <div
            className="
              text-xs
              text-body
            "
          >
            Vence: {formatDateOnly(row.original.expirationDate) || '—'}
          </div>

          {/* 🔹 Status */}

          <div>
            <span
              className={`
                inline-flex

                rounded-lg

                px-2
                py-1

                text-[11px]
                font-medium

                ${
                  row.original.status === 'ACTIVE'
                    ? 'bg-[#3CA745] text-white'
                    : ''
                }

                ${
                  row.original.status === 'CANCELLED'
                    ? 'bg-[#DC3545] text-white'
                    : ''
                }

                ${
                  row.original.status === 'EXPIRED'
                    ? 'bg-[#F9C107] text-[#212B36]'
                    : ''
                }

                ${
                  row.original.status === 'PROCESSED'
                    ? 'bg-primary text-white'
                    : ''
                }
              `}
            >
              {row.original.status}
            </span>
          </div>
        </div>
      ),
    },

    // =====================================================
    // 🔹 Total
    // =====================================================

    {
      Header: 'Total',

      accessor: 'total',

      showStatus: true,

      customCell: ({ value }) => (
        <div className="min-w-[140px]">
          <span
            className="
              text-base
              font-bold
              text-primary
            "
          >
            ${formatCurrency(value || 0)}
          </span>
        </div>
      ),
    },
  ];
